import styled from 'styled-components';

export const Container = styled.div`
  /* display: flex; */
  height: 100vh;
  background: #fff;
  /* overflow: hidden; */
  padding: 0 20px;

    
    @media (min-width: 1000px) {
      display: flex;
      flex-direction: row;
      /* align-items: stretch; */
    }
`;

export const Content = styled.div`
  flex-shrink: 0;
  flex-grow: 8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  @media (min-width: 1000px) {
    justify-content: center;
  }
`;

export const LoginContainer = styled.div`
  margin: auto;
  padding: 0 20px;
`;

export const Infos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h2 {
    font-family: 'Roboto', sans-serif;
    /* color: #03cc95; */
    color: #333;
  }

  img {
    width: 200px;
    height: auto;
  }

  > h1 {
    font-family: 'Inter', sans-serif;
    /* color: #333; */
    /* color: #03cc95; */
    color: #333;
    font-weight: 500;
    font-size: 32px;
    /* margin: 15px 0; */
    margin-bottom: 10px;
  }

  > p {
    margin-bottom: 30px;
    font-family: 'Inter', sans-serif;
    font-size: 15px;
    color: #333;
  }
`;

export const Form = styled.form`
    width: 100%;
    a {
      font-size: 15px;
      /* color: #4c83ee; */
          &:hover {
            /* color: #566583; */
          }
    }
    
    .field {
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin-bottom: 10px;

        .label {
          font-family: 'roboto', sans-serif;
        }
    }

    .utils {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;
        
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 30px;

        > button {
            padding: 8px 18px;
            font-family: 'Roboto', sans-serif;
            cursor: pointer;
            font-size: 18px;
        }

        
    }

     @media (min-width: 980px) {
      width: 420px;
  }
`;

